<template>
    <div id="selectModal"></div>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 text-2xl font-bold">
                Dettaglio utente
            </div>

            <div v-show="response_message.length" :class="[esito ? 'bg-next-bri' : 'bg-next-orange']"
                 class="text-white p-3 mb-3 flex justify-between items-center">
                {{ response_message }}
                <i class="icon-x cursor-pointer" @click="response_message = ''"></i>
            </div>

            <p>Nome utente: <span class="font-bold">{{ utente.name }}</span></p>
            <p>Email: <span class="font-bold">{{ utente.email }}</span></p>
            <div class="pt-5 flex flex-col">

                <Field field_name="Gruppi">
                    <VueMultiselect
                        v-model="gruppiAutcomplete.selection"
                        :options="gruppiAutcomplete.options"
                        placeholder="Gruppi"
                        class="next-vue-multiselect"
                        track-by="id"
                        label="name"
                        :multiple="true"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :internal-search="false"
                        @search-change="gruppiAutcomplete.search"
                    >
                        <template v-slot:tag="{option, remove}">
                            <MultiselectOption @remove="remove(option)">
                                {{ option.name }}
                            </MultiselectOption>
                        </template>
                    </VueMultiselect>
                </Field>
            </div>

            <div class="pt-5 flex flex-col">

                <Field field_name="Permessi">
                    <VueMultiselect
                        v-model="permessiAutcomplete.selection"
                        :options="permessiAutcomplete.options"
                        placeholder="Permessi"
                        class="next-vue-multiselect"
                        track-by="id"
                        label="name"
                        :multiple="true"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :internal-search="false"
                        :close-on-select="false"
                        @search-change="permessiAutcomplete.search"
                    >
                        <template v-slot:tag="{option, remove}">
                            <MultiselectOption @remove="remove(option)">
                                {{ option.name }}
                            </MultiselectOption>
                        </template>
                    </VueMultiselect>
                </Field>
            </div>

            <div class="pt-5 flex flex-col">
                <Field field_name="Utente responsabile">
                    <VueMultiselect
                        v-model="userAutocomplete.selection"
                        :options="userAutocomplete.options"
                        placeholder="Utente controllore"
                        class="next-vue-multiselect-single"
                        track-by="id"
                        label="name"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :internal-search="false"
                        @search-change="userAutocomplete.search"
                    >
                    </VueMultiselect>
                </Field>
            </div>

            <div>
                <p>Questo utente è responsabile di:</p>
                <ul class="pl-4 list-disc">
                    <li v-for="r in responsabileDi">
                        {{ r.name }}
                    </li>
                </ul>
            </div>

            <div class="pt-5 flex flex-col mb-5">

                <Field field_name="Business unit">
                    <VueMultiselect :searchable="true"
                                    :loading="buAutocomplete.isLoading"
                                    :internal-search="false"
                                    trackBy="id"
                                    label="nome"
                                    @search-change="buAutocomplete.search"
                                    v-model="buAutocomplete.selection"
                                    :options="buAutocomplete.options"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    class="next-vue-multiselect-single"
                                    placeholder="Business Unit"
                                    deselectLabel="Deseleziona"
                                    selectedLabel="Selezionato"
                                    selectLabel="Seleziona"
                    >
                        <template v-slot:option="{option, props}">
                                <span
                                    class="relative inline-block p-2 group">
                                    <span class="mr-2 border border-next p-1">{{ option.label }}</span><span
                                    class="mr-1">{{ option.nome }}</span>
                                </span>
                        </template>
                    </VueMultiselect>
                </Field>
            </div>

            <Alert v-if="errors['ore']?.length" class="bg-next-orange">
                {{ errors['ore'][0] }}
            </Alert>

            <div class="my-3">
                <div class="font-bold pb-2 text-sm">Ora lavorative</div>

                <div class="grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 ">
                    <p class="font-bold pb-2 text-sm">Dal</p>
                    <p class="font-bold pb-2 text-sm">Al</p>
                    <p class="font-bold pb-2 text-sm">Ore</p>
                    <p class="w-8">&nbsp;</p>
                </div>

                <div v-for="(ora, i) in ore" :key="i"
                     class="grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 mb-3">
                    <div class="flex flex-col">
                        <Field :label-visible="false" :errors="getErrors(i,'ore', 'data_inizio')">
                            <input v-model="ora.data_inizio" type="date"
                                   class="p-7px bg-next-gray-md-dark hover:bg-white">
                        </Field>
                    </div>
                    <div class="flex flex-col">
                        <Field :label-visible="false" :errors="getErrors(i,'ore', 'data_fine')">
                            <input v-model="ora.data_fine" type="date"
                                   class="p-7px bg-next-gray-md-dark hover:bg-white">
                        </Field>
                    </div>
                    <div class="flex flex-col">
                        <Field :label-visible="false" :errors="getErrors(i,'ore', 'ore')">
                            <input v-model="ora.ore" type="number" step="1"
                                   class="p-7px bg-next-gray-md-dark hover:bg-white">
                        </Field>
                    </div>
                    <div class="flex items-center">
                        <NextButton variant="outline-secondary" @click="removeOre(i)"
                                    class="col flex justify-center items-center h-8 w-8"><i class="icon-x"></i>
                        </NextButton>
                    </div>
                </div>

            </div>

            <div class="flex justify-end">
                <NextButton variant="primary" @click="addOre"
                            class="col flex justify-center items-center h-8 w-8"><i
                    class="icon-croce_quadrata"></i>
                </NextButton>
            </div>

            <template v-if="hasPermission('can_import_costi_timesheet')">

                <Alert v-if="errors['bu_costi']?.length" class="bg-next-orange my-3">
                    {{ errors['bu_costi'][0] }}
                </Alert>

                <div class="font-bold pb-2 text-sm">Costi utente per business unit</div>

                <div class="grid grid-cols-[repeat(4,_minmax(0,_1fr))_max-content] gap-4 ">
                    <p class="font-bold pb-2 text-sm">Dal</p>
                    <p class="font-bold pb-2 text-sm">Al</p>
                    <p class="font-bold pb-2 text-sm">Business unit</p>
                    <p class="font-bold pb-2 text-sm">Costo</p>
                    <p class="w-8">&nbsp;</p>
                </div>

                <div v-for="(bu_costo, i) in bu_costi" :key="i"
                     class="grid grid-cols-[repeat(4,_minmax(0,_1fr))_max-content] gap-4 mb-3">
                    <div class="flex flex-col">
                        <Field :label-visible="false" :errors="getErrors(i,'bu_costi', 'data_inizio')">
                            <input v-model="bu_costo.data_inizio" type="date"
                                   class="p-7px bg-next-gray-md-dark hover:bg-white">
                        </Field>
                    </div>
                    <div class="flex flex-col">
                        <Field :label-visible="false" :errors="getErrors(i,'bu_costi', 'data_fine')">
                            <input v-model="bu_costo.data_fine" type="date"
                                   class="p-7px bg-next-gray-md-dark hover:bg-white">
                        </Field>
                    </div>
                    <div class="flex flex-col">
                        <Field :label-visible="false" :errors="getErrors(i,'bu_costi', 'business_unit_id')">
                            <ModalInput
                                :autocomplete="buCostiAutocomplete"
                                @confirm="bu_costo.business_unit = $event"
                                track-by="id"
                                label="nome"
                                class="next-vue-multiselect-single">
                                <template v-slot:cell="option">
                                    <div class="p-2 bg-next-gray-md-dark hover:bg-white w-full">
                                        {{ bu_costo?.business_unit?.nome || 'Scegli una BU' }}
                                    </div>
                                </template>
                            </ModalInput>
                        </Field>
                    </div>
                    <div class="flex flex-col">
                        <Field :label-visible="false" :errors="getErrors(i,'bu_costi', 'costo_orario')">
                            <input v-model="bu_costo.costo_orario" type="number" step="0.01"
                                   class="p-7px bg-next-gray-md-dark hover:bg-white">
                        </Field>
                    </div>
                    <div class="flex items-center">
                        <NextButton variant="outline-secondary" @click="remove(i)"
                                    class="col flex justify-center items-center h-8 w-8"><i class="icon-x"></i>
                        </NextButton>
                    </div>
                </div>

                <div class="flex justify-end">
                    <NextButton variant="primary" @click="add"
                                class="col flex justify-center items-center h-8 w-8"><i class="icon-croce_quadrata"></i>
                    </NextButton>
                </div>
            </template>

            <div class="flex pt-3 justify-between">
                <NextButton v-if="hasPermission('delete users')" class="px-3 py-2" @click="toggleCancella">
                    {{ isDeleted ? 'Riabilita utente' : 'Cancella utente' }}
                </NextButton>
                <span v-else></span>
                <NextButton class="px-3 py-2" @click="save">Salva</NextButton>
            </div>


        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Topbar from "../../components/Topbar.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import ModalFigli from "@/components/ModalFigli.vue";
import NextEditor from "@/components/NextEditor.vue";
import Loading from "@/components/Loading.vue";
import Alert from '@/components/Alert.vue';
import MultiselectOption from "@/components/MultiselectOption.vue";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import Checkbox from "@/components/Checkbox.vue";
import userManager from "@/api/Users";
import Autocomplete from "@/setup/Autocomplete";
import gruppoManager from "@/api/Gruppi";
import permessiManager from "@/api/Permessi";
import businessUnitsManager from "@/api/BusinessUnits";
import {mapGetters} from "vuex";
import ModalInput from "@/components/ModalInput.vue";
import Select from "@/components/Select.vue";
import businessUnitsUserCostiManager from "@/api/BusinessUnitsUserCosti";

@Options({
    name: 'DettaglioUtente',
    components: {
        Select,
        ModalInput,
        Checkbox,
        NextButton,
        Topbar,
        NextEditor,
        Breadcrumbs,
        ModalFigli,
        Loading,
        MultiselectOption,
        Field,
        Alert
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        },
        cid: {
            type: [String, Number],
            required: true
        },
    },
    computed: {
        ...mapGetters([
            'hasPermission',
        ])
    },
})
export default class DettaglioUtente extends Vue {
    gruppiAutcomplete: any = setup(() => Autocomplete(gruppoManager, true))
    permessiAutcomplete: any = setup(() => Autocomplete(permessiManager, true))
    buAutocomplete: any = setup(() => Autocomplete(businessUnitsManager, false))
    buCostiAutocomplete: any = setup(() => Autocomplete(businessUnitsManager, false))
    userAutocomplete: any = setup(() => Autocomplete(userManager))

    id!: number
    hasPermission!: any
    utente: any = {}
    esito = false
    response_message = ''
    bu_costi: any[] = []
    ore: any[] = []
    errors: any = {}
    responsabileDi: any[] = []

    async created() {
        await this.buAutocomplete.search('', 0)
        await this.fetchUser()
    }

    add() {
        this.bu_costi.push([{id:null, business_unit_id: null, data_fine: null, data_inizio: null, costo_orario: 0}])
    }

    addOre() {
        this.ore.push([{id:null, data_inizio: null, data_fine: null, ore: 0}])
    }

    removeOre(idx: number) {
        this.ore.splice(idx, 1)
    }

    remove(idx: number) {
        this.bu_costi.splice(idx, 1)
    }

    getErrors(index: string | number, prefix:string, field: string) {
        return (this.errors as any)[`${prefix}.${index}.${field}`]
    }

    fetchUser() {
        userManager.user(this.id).then((response) => {
            this.utente = response.data
            if (this.utente.business_unit_id) {
                businessUnitsManager.businessUnit(this.utente.business_unit_id).then((res) => {
                    this.buAutocomplete.add(res.data)
                })
            }
            this.userAutocomplete.retrieve(this.utente.responsabile_id)
        })

        userManager.oreLavorative(this.id).then((response) => {
            this.ore = response.data
        })

        userManager.responsabileDi(this.id).then((response) => {
            this.responsabileDi = response.data
        })

        userManager.roles(this.id).then((response) => {
            this.gruppiAutcomplete.add(response.data)
        })

        userManager.businessUnitCosti(this.id).then((response) => {
            this.bu_costi = response.data
        })

        userManager.permissions(this.id).then((response) => {
            this.permessiAutcomplete.add(response.data)
        })
    }

    save() {
        this.response_message = ''
        userManager.saveRolePermissions(this.id, {
            role_ids: this.gruppiAutcomplete.selection.map((e: any) => e.id),
            permission_ids: this.permessiAutcomplete.selection.map((e: any) => e.id),
            business_unit_id: this.buAutocomplete.selection?.id || null,
            responsabile_id: this.userAutocomplete.selection?.id || null,
            bu_costi: this.bu_costi.map((r) => {
                return {
                    id: r.id,
                    costo_orario: r.costo_orario,
                    business_unit_id: r.business_unit?.id,
                    data_inizio: r.data_inizio,
                    data_fine: r.data_fine
                }
            }),
            ore: this.ore.map((r) => {
                return {
                    id: r.id,
                    data_inizio: r.data_inizio,
                    data_fine: r.data_fine,
                    ore: r.ore
                }
            })
        }).then(() => {
            this.esito = true
            this.errors = {}
            this.response_message = 'Salvataggio avvenuto corretamente'
        }).catch((res) => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
            }
            this.esito = false
            this.response_message = 'Salvataggio fallito'
        })
    }

    get isDeleted() {
        return this.utente?.deleted_at
    }

    toggleCancella() {
        if (this.isDeleted) {
            userManager.restore(this.id).then(() => {
                this.fetchUser()
            })
        } else {
            userManager.delete(this.id).then(() => {
                this.fetchUser()
            })
        }
    }

}
</script>


<style lang="scss">

</style>
